import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import intl from 'react-intl-universal';
import { InfoLabel, InfoValue, EmptyLabel } from './styles';
import { IssuePropTypes } from 'shared/propTypes/issueType';
import { getTextContentsFromHtmlString } from 'utils/browser';
import { TextEditedContent } from 'components';
import Grid from '@mui/material/Grid2';
import { Chip } from '@mui/material';
import localData from 'utils/localData';
import { USER_DATA } from 'shared/constants/users';
import logger from 'utils/logger';

const propTypes = {
  issue: PropTypes.shape(IssuePropTypes).isRequired,
};

const log = logger.createLogger('IssueDetailsAIInfo');

const IssueDetailsAIInfo = ({ issue }) => {
  const languageCode = localData.get(USER_DATA.PREFFERED_LANGUAGE);

  const isDescriptionEmpty =
    getTextContentsFromHtmlString(issue.description).trim().length === 0;

  const renderTags = () => {
    return (
      <>
        <Grid size={2}>
          <InfoLabel>{intl.get('issue_details_text_tags')}</InfoLabel>
        </Grid>
        <Grid size={10}>
          {issue.tags.map((tag, index) => {
            let tagLabelText = tag;
            if (tag && Object.prototype.hasOwnProperty.call(tag, 'content')) {
              tagLabelText =
                tag.content.displayName[languageCode] ||
                tag.content.displayName['en-US'] ||
                Object.values(tag.content.displayName)[0];
            } else if (
              tag &&
              Object.prototype.hasOwnProperty.call(tag, 'labelText')
            ) {
              tagLabelText = tag;
            }
            return <Chip key={index} label={tagLabelText} variant="outlined" />;
          })}
        </Grid>
      </>
    );
  };

  return (
    <Fragment>
      <Grid container spacing={1}>
        <Grid size={2}>
          <InfoLabel>
            {intl.get('issue_details_info_label_patient_name')}
          </InfoLabel>
        </Grid>
        <Grid size={10}>
          <InfoValue>{issue.patientName}</InfoValue>
        </Grid>
        <Grid size={2}>
          <InfoLabel>
            {intl.get('issue_details_info_label_patient_gender')}
          </InfoLabel>
        </Grid>
        <Grid size={10}>
          <InfoValue>{issue.patientGender}</InfoValue>
        </Grid>
        {renderTags()}
        <Grid size={2}>
          <InfoLabel>{intl.get('issue_details_info_label_from')}</InfoLabel>
        </Grid>
        <Grid size={10}>
          <InfoValue>{issue.srcOrgName}</InfoValue>
        </Grid>
        <Grid size={2}>
          <InfoLabel>
            {intl.get('issue_details_info_label_doctor_in_charge')}
          </InfoLabel>
        </Grid>
        <Grid size={10}>
          <InfoValue>{issue.doctorsInCharge.join(', ')}</InfoValue>
        </Grid>
        <Grid size={2}>
          <InfoLabel>
            {intl.get('issue_details_info_label_department')}
          </InfoLabel>
        </Grid>
        <Grid size={10}>
          <InfoValue>{issue.department}</InfoValue>
        </Grid>
        <Grid size={2}>
          <InfoLabel>{intl.get('issue_details_text_description')}</InfoLabel>
        </Grid>
        <Grid size={10}>
          {isDescriptionEmpty ? (
            <EmptyLabel>
              {intl.get('issue_details_placeholder_no_description')}
            </EmptyLabel>
          ) : (
            <TextEditedContent content={issue.description} />
          )}
        </Grid>
      </Grid>
    </Fragment>
  );
};

IssueDetailsAIInfo.propTypes = propTypes;

export default IssueDetailsAIInfo;
